import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Ideas by Lane of Support',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  slices: {
                    '[]': [
                      {
                        '{}': {
                          name: 'OOTB Enablement',
                          value: {
                            '#': {
                              '@': 'ootbEnablement',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Proprietary agents & workflows',
                          value: {
                            '#': {
                              '@': 'proprietaryAgentsWorkflows',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Platform & Co-Dev',
                          value: {
                            '#': {
                              '@': 'platformCoDev',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
    },
  },
  subqueries: {
    platformCoDev: {
      filter: {
        '=': [
          {
            '@.': '!lane_of_support',
          },
          'Platform & Co-Dev',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    ootbEnablement: {
      filter: {
        '=': [
          {
            '@.': '!lane_of_support',
          },
          'OOTB Enablement',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    proprietaryAgentsWorkflows: {
      filter: {
        '=': [
          {
            '@.': '!lane_of_support',
          },
          'Proprietary agents & workflows',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
  },
}
